import { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import TableHeader from "@commons/Table/TableHeader";
import Heading from "@commons/Typography/Heading";
import AdditionalDataTable from "./AdditionalDataTable";
import SampleTable from "./SampleTable";
import RegisterTable from "./RegisterTable";
import { useExportIndividualsAdditionalData } from "@hooks/exports/useExportIndividualAdditionalData";
import { useExportRegisters } from "@hooks/exports/useExportRegisters";
import { useExportSamples } from "@hooks/exports/useExportSamples";
type EventTypes = "additionalData" | "sample" | "register";

function IndividualsEventTable({ individualId }: { individualId: string }) {
  const [selectedEvent, setSelectedEvent] =
    useState<EventTypes>("additionalData");

  const additionalData = useExportIndividualsAdditionalData();
  const samples = useExportSamples();
  const registers = useExportRegisters();

  const handleExport = () => {
    switch (selectedEvent) {
      case "additionalData":
        additionalData.handleExport(individualId);
        break;
      case "sample":
        samples.handleExport({ individualId });
        break;
      case "register":
        registers.handleExport({ individualId });
        break;
    }
  };

  const isExporting =
    additionalData.isLoading || samples.isLoading || registers.isLoading;

  return (
    <div className="w-full h-full bg-white p-4 shadow-md rounded-2xl max-h-fit">
      <TableHeader.Root>
        <Heading className="font-roboto">Prontuário e outros eventos</Heading>
        <TableHeader.Button
          customVariant="dark"
          onClick={handleExport}
          disabled={isExporting}
        >
          {isExporting ? "Exportando..." : "Exportar .csv"}
        </TableHeader.Button>
      </TableHeader.Root>

      <div>
        <Tabs
          value={selectedEvent}
          onChange={(_, newValue) => setSelectedEvent(newValue)}
          textColor="primary"
          indicatorColor="primary"
          aria-label="tabs de eventos"
          className="mt-2"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab value="additionalData" label="Dados Adicionais" />
          <Tab value="sample" label="Amostras" />
          <Tab value="register" label="Registros" />
        </Tabs>

        {selectedEvent === "additionalData" && (
          <AdditionalDataTable individualId={individualId} />
        )}

        {selectedEvent === "sample" && (
          <SampleTable individualId={individualId} />
        )}

        {selectedEvent === "register" && (
          <RegisterTable individualId={individualId} />
        )}
      </div>
    </div>
  );
}

export default IndividualsEventTable;
